export default __webpack_public_path__ + "static/media/Payroll-3.b4a9adaf.png";